module.exports = __webpack_public_path__ + "img/d-background.c1f1aea9.png";